export const CategorizedListItemDate = ({ children }) => (
  <p className="mb-2 text-sm text-[#6C7275]">{children}</p>
)
